import { jsPDF } from "jspdf";

const NAVY = "#062546";
const BLUE = "#1674d1";
const AQUA = "#3ba99a";
const GREY = "#4c6371";

export function downloadProductLiterature(product) {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const width = doc.internal.pageSize.getWidth();
  const marginX = 48;
  const contentWidth = width - marginX * 2;
  let y = 56;

  // Header band
  doc.setFillColor(NAVY);
  doc.rect(0, 0, width, 96, "F");

  doc.setTextColor("#ffffff");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("Nawan Laboratories", marginX, 44);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor("#86e9df");
  doc.text("PRODUCT LITERATURE", marginX, 66);

  doc.setTextColor("#c9dfe5");
  doc.setFontSize(9);
  const timestamp = new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  doc.text(`Issued: ${timestamp}`, width - marginX, 66, { align: "right" });

  y = 148;

  // Title block
  doc.setTextColor(NAVY);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(28);
  doc.text(product.name, marginX, y);

  y += 22;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(13);
  doc.setTextColor(GREY);
  doc.text(`${product.generic} · ${product.division}`, marginX, y);

  y += 18;
  doc.setFontSize(11);
  doc.setTextColor(BLUE);
  doc.text(product.form.toUpperCase(), marginX, y);

  y += 14;
  doc.setDrawColor(AQUA);
  doc.setLineWidth(1);
  doc.line(marginX, y, marginX + 72, y);

  y += 30;

  // Sections
  const sections = [
    ["Composition", product.composition],
    ["Therapeutic indication", product.indications],
    ["Recommended dosage", product.dosage],
    ["Storage", "Store below 30°C in a dry place, protected from light. Keep out of reach of children."],
    ["Manufactured by", "Nawan Pharmaceutical Laboratories (Pvt.) Ltd., 136–138, Sector 15, Korangi Industrial Area, Karachi, Pakistan."],
    ["Literature reference", product.literature || product.name],
  ];

  sections.forEach(([label, value]) => {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.setTextColor(BLUE);
    doc.text(label.toUpperCase(), marginX, y);
    y += 14;
    doc.setFont("helvetica", "normal");
    doc.setFontSize(11);
    doc.setTextColor(NAVY);
    const wrapped = doc.splitTextToSize(value, contentWidth);
    doc.text(wrapped, marginX, y);
    y += wrapped.length * 15 + 12;

    if (y > 720) {
      doc.addPage();
      y = 64;
    }
  });

  // Footer band
  const footerY = doc.internal.pageSize.getHeight() - 46;
  doc.setDrawColor("#dfe8ec");
  doc.line(marginX, footerY, width - marginX, footerY);
  doc.setFontSize(9);
  doc.setTextColor(GREY);
  doc.text("This literature is a summary. Refer to the printed pack insert for the full prescribing information.", marginX, footerY + 18);
  doc.setTextColor(BLUE);
  doc.text("info@nawanlab.com  ·  +92 (21) 35065835", width - marginX, footerY + 18, { align: "right" });

  const filename = `${product.name.replace(/\s+/g, "-").toLowerCase()}-literature.pdf`;
  doc.save(filename);
}
